import * as React from 'react';
import withComponentBase from '../../helpers/with-component-base';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var Billboard = function Billboard(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
      primaryContent = _ref.primaryContent,
      primarySlot = _ref.primarySlot,
      fullWidthSlot = _ref.fullWidthSlot,
      bgImage = _ref.bgImage,
      mobileImage = _ref.mobileImage,
      _ref$showImageOnMobil = _ref.showImageOnMobile,
      showImageOnMobile = _ref$showImageOnMobil === void 0 ? false : _ref$showImageOnMobil;

  var styles = function styles() {
    if (primarySlot) {
      return 'modules.billboard.primaryContent';
    }

    return "modules.billboard.".concat(fullWidthSlot ? 'contentWithFullWidthSlot' : 'contentWithoutFullWidthSlot');
  };

  return _jsx("div", {
    children: _jsx("div", {
      sx: {
        variant: 'modules.billboard.container'
      },
      children: _jsxs("div", {
        sx: {
          display: 'flex',
          flexDirection: 'column',
          paddingBottom: fullWidthSlot ? ['0', 'xs'] : '0',
          variant: 'modules.billboard.wrapper'
        },
        children: [breadcrumbs ? _jsx("div", {
          sx: {
            variant: !primarySlot && bgImage ? 'modules.billboard.breadcrumbsWithImage' : 'modules.billboard.breadcrumbs'
          },
          children: /*#__PURE__*/React.cloneElement(breadcrumbs, {
            variant: 'billboard'
          })
        }) : null, mobileImage ? _jsx("div", {
          sx: {
            width: ['100%', '404px', '404px'],
            height: ['0', '255px', '416px'],
            margin: ['30px auto', '30px auto', '0'],
            paddingTop: ['35%', '0', '0'],
            display: ['block', 'block', 'none'],
            backgroundImage: "url(".concat(mobileImage, ")"),
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            variant: 'modules.billboard.bgImagePosition'
          }
        }) : null, !bgImage ? _jsx("div", {
          sx: {
            variant: 'modules.billboard.primaryContainer'
          }
        }) : null, _jsxs("div", {
          sx: {
            marginBottom: fullWidthSlot ? ['lg', primarySlot ? 'xxl' : 'lg'] : !primarySlot && bgImage && showImageOnMobile ? 0 : !primarySlot && bgImage && !showImageOnMobile ? ['xl', 'xxl', '0'] : ['xl', 'xxl'],
            display: 'flex',
            height: ['auto', 'auto', 'auto'],
            minHeight: !primarySlot && bgImage ? [undefined, undefined, '416px'] : undefined,
            flexDirection: ['column', 'column', 'row'],
            justifyContent: ['center', 'center', 'space-between'],
            position: 'relative',
            alignItems: ['flex-end', 'center']
          },
          children: [_jsx("div", {
            sx: {
              alignSelf: 'center',
              textAlign: primarySlot || bgImage ? 'left' : 'center',
              variant: styles(),
              marginX: primarySlot || bgImage ? ['0', 'auto', '0'] : 'auto',
              width: ['auto', '70%', '50%'],
              'ul > li': {
                fontSize: ['sm', 'md'],
                paddingY: 10
              }
            },
            children: primaryContent
          }), primarySlot ? _jsx("div", {
            sx: {
              variant: 'modules.billboard.primarySlot',
              width: ['100%', '70%', '40%'],
              marginTop: ['0', 'lg', '0'],
              marginX: ['auto', 'auto', '0']
            },
            children: /*#__PURE__*/React.cloneElement(primarySlot, {
              variant: 'billboard'
            })
          }) : null, !primarySlot && bgImage ? _jsx("div", {
            sx: {
              width: ['90%', '404px', '404px'],
              height: ['0', '255px', '416px'],
              position: ['static', 'static', 'absolute'],
              bottom: 0,
              right: 0,
              margin: ['30px auto 0', '30px auto 0', '0'],
              paddingTop: ['60%', '0', '0'],
              display: [showImageOnMobile && !mobileImage ? 'block' : 'none', showImageOnMobile && !mobileImage ? 'block' : 'none', 'block'],
              backgroundImage: ["url(".concat(mobileImage || bgImage, ")"), "url(".concat(bgImage, ")")],
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'contain',
              variant: 'modules.billboard.bgImagePosition'
            }
          }) : null]
        }), fullWidthSlot ? _jsx("div", {
          sx: {
            width: ['100%', '70%', '100%'],
            marginX: ['0', 'auto', '0'],
            variant: 'modules.billboard.fullWidthSlot'
          },
          children: fullWidthSlot
        }) : null]
      })
    })
  });
};

Billboard.displayName = 'Billboard';
export default withComponentBase(Billboard, {
  withPalette: true
});
//# sourceMappingURL=billboard.js.map